import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    title: 'Your AI Cooking Assistant',
    subtitle: 'Transform ingredients into delicious recipes with the power of AI',
    description: 'Simply snap a photo of your ingredients, and our AI will create a personalized recipe tailored just for you.',
    cta: 'Start Cooking',
    scanIngredient: 'Scan Ingredients',
    getRecipe: 'Get Recipe',
    cookMeal: 'Cook Meal'
  },
  sl: {
    title: 'Vaš AI pomočnik za kuhanje',
    subtitle: 'Spremenite sestavine v okusne recepte z močjo umetne inteligence',
    description: 'Preprosto fotografirajte svoje sestavine in naša umetna inteligenca bo ustvarila personaliziran recept samo za vas.',
    cta: 'Začnite kuhati',
    scanIngredient: 'Skeniraj sestavine',
    getRecipe: 'Pridobi recept',
    cookMeal: 'Skuhaj obrok'
  }
};

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="bg-gradient-to-br from-emerald-50 to-white py-20 px-4">
      <div className="container mx-auto max-w-7xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-5xl md:text-6xl font-bold text-dark mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {t.title}
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" style={{ fontFamily: 'Lato, sans-serif' }}>
              {t.subtitle}
            </p>
            <p className="text-lg text-gray-700 mb-10 leading-relaxed">
              {t.description}
            </p>
            <a 
              href="/start"
              className="inline-block px-8 py-4 bg-gradient-green text-white rounded-lg text-lg font-semibold hover:opacity-90 transition shadow-lg"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t.cta} →
            </a>
          </div>
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <div className="w-full h-48 bg-gradient-to-br from-emerald-100 to-emerald-200 rounded-lg flex items-center justify-center">
                    <span className="text-4xl">📸</span>
                  </div>
                  <h3 className="mt-4 font-semibold text-center">{t.scanIngredient}</h3>
                </div>
              </div>
              <div className="space-y-4 mt-12">
                <div className="bg-white p-6 rounded-xl shadow-lg">
                  <div className="w-full h-48 bg-gradient-to-br from-orange-100 to-orange-200 rounded-lg flex items-center justify-center">
                    <span className="text-4xl">🍳</span>
                  </div>
                  <h3 className="mt-4 font-semibold text-center">{t.cookMeal}</h3>
                </div>
              </div>
              <div className="bg-white p-6 rounded-xl shadow-lg col-span-2">
                <div className="w-full h-48 bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg flex items-center justify-center">
                  <span className="text-4xl">📋</span>
                </div>
                <h3 className="mt-4 font-semibold text-center">{t.getRecipe}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
